export default {

    SET_SELECT_TREASURER({commit},Treasurer){
        commit('SET_SELECT_TREASURER',Treasurer)
    },
    SET_RESULT({commit},result){
        commit('SET_RESULT',result)
    },
    SET_EDIT_TREASURER({commit},editTreasurer){
        commit('SET_EDIT_TREASURER',editTreasurer)
    },
}